<template>
  <div class="custom">
    <div class="fx">
      <div class="title">可选材质：</div>
      <div class="selectBoxWatch selectBox">
        <el-select
          @change="
            () => {
              getQuantity()
              getPriceRange()
            }
          "
          :popper-append-to-body="false"
          v-model="dataFrom.texture"
          clearable
          placeholder
        >
          <div>
            <el-option
              v-for="(item, index) in dataFrom.textureList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </div>
        </el-select>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="fx">
      <div class="title">金<span class="hidden">间隔</span>重：</div>
      <div class="selectBox">
        <el-select
          @change="
            () => {
              getQuantity()
              getPriceRange()
            }
          "
          :popper-append-to-body="false"
          v-model="dataFrom.goldWeigh"
          clearable
          placeholder
        >
          <div>
            <el-option
              v-for="(item, index) in dataFrom.mainStoneList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </div>
        </el-select>
      </div>
    </div>
    <el-divider></el-divider>

    <template v-if="!['景翠直播'].includes(DataList.productRemark)">
      <template v-if="['潮流爆款'].includes(DataList.productRemark)">
        <div class="fx">
          <div class="title">库存：</div>
          <div class="selectBox" style="width: 500px; text-align: right;">
            <el-radio-group
              v-if="!['戒指', '手镯'].includes(DataList.category)"
              v-model="dataFrom.supplier.supplierCode"
              @input="handleInputSupplier"
            >
              <el-radio
                style="display: block; margin: 8px 0 8px 0"
                v-for="item in supplierOptions"
                :key="item.supplierCode"
                :label="item.supplierCode"
                :disabled="!item.number"
              >
                库存： {{ item.number || 0 }}
              </el-radio>
            </el-radio-group>

            <el-radio-group
              v-if="['戒指', '手镯'].includes(DataList.category)"
              v-model="dataFrom.supplier.specifications"
              @input="handleInputQuantity"
            >
              <el-radio
                style="display: block; margin: 8px 0 8px 0"
                v-for="item in supplierOptions"
                :key="item.specifications"
                :label="item.specifications"
                :disabled="!item.number"
              >
                {{ item.specifications }} - 库存：
                {{ item.number || 0 }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-divider></el-divider>
      </template>
      <template v-else>
        <div class="fx">
          <div class="title">
            供应商：
          </div>
          <div class="selectBox" style="width: 500px; text-align: right;">
            <el-radio-group
              v-model="dataFrom.supplier.supplierCode"
              @input="handleInputSupplier"
            >
              <el-radio
                style="display: block; margin: 8px 0 8px 0"
                v-for="item in supplierOptions"
                :key="item.supplierCode"
                :label="item.supplierCode"
                :disabled="!item.number"
              >
                {{ item.supplierName }} - 库存： {{ item.number || 0 }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-divider></el-divider>
      </template>
    </template>

    <template v-if="['景翠直播'].includes(DataList.productRemark)">
      <div class="fx">
        <div class="title">规格：</div>
        <div class="selectBox" style="width: 500px; text-align: right;">
          <el-radio-group v-model="dataFrom.maintainSpecification">
            <el-radio
              style="display: block; margin: 8px 0 8px 0"
              v-for="item in dataFrom.maintainSpecificationList"
              :key="item"
              :label="item"
            >
              {{ item }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <el-divider></el-divider>
    </template>

    <!-- 主推款 -->
    <template v-if="packageList.length !== 0">
      <div class="fx" style="align-items: flex-start">
        <div class="title">
          主推款：
        </div>
        <div
          class="selectBox"
          style="width: 500px; max-height: 200px; text-align: left; overflow-y: auto;"
        >
          <div
            v-for="item in packageList"
            :key="item.styleNumber"
            style="line-height: 24px;"
          >
            <span style="display: inline-block; width: 100px;">
              {{ item.styleNumber }}
            </span>
            <span style="display: inline-block; width: 300px;">
              {{ item.productName }}
            </span>
            <span style="display: inline-block; width: 20px;">*1</span>
            <!-- {{ `${item.styleNumber} ${item.productName} *1` }} -->
          </div>
        </div>
      </div>
      <el-divider></el-divider>
    </template>

    <!-- 产品规格 -->
    <template v-if="dataFrom.productSpecification">
      <div class="fx">
        <div class="title">
          产品规格：
        </div>
        <div class="value-font ">
          {{ dataFrom.productSpecification }}
        </div>
      </div>
      <el-divider></el-divider>
    </template>

    <!-- 工费 -->
    <div class="fx">
      <div class="title">
        计件加工费：
      </div>
      <div class="value-font ">
        {{ dataFrom.pieceRateCost }}
      </div>
    </div>
    <el-divider></el-divider>
    <!-- 工费 -->
    <div
      class="fx"
      v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理')"
    >
      <div class="title">
        批发克工费：
      </div>
      <div class="value-font ">
        {{ dataFrom.wholesaleLaborCost }}
      </div>
    </div>
    <el-divider
      v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理')"
    ></el-divider>

    <!-- 珐琅件工费 -->
    <div class="fx">
      <span class="title">珐琅件工费：</span>
      <div class="value-font ">
        {{ dataFrom.enamelCost }}
      </div>
    </div>
    <el-divider></el-divider>

    <!-- 主石单价 -->
    <div class="fx">
      <span class="title">主石单价：</span>
      <div class="value-font ">
        {{ dataFrom.mainUnitPrice }}
      </div>
    </div>
    <el-divider></el-divider>

    <!-- 证书费 -->
    <div class="fx">
      <span class="title">证书费：</span>
      <div class="value-font ">
        {{ dataFrom.certificatePrice }}
      </div>
    </div>
    <el-divider></el-divider>

    <!-- 下单件数 -->
    <div class="fx box_detail_input">
      <span class="title placeNum">下单件数：</span>

      <div>
        <span class="prompt">（起订量{{ leastQuantity }}）</span>
        <el-input-number
          v-model="dataFrom.quantity"
          @change="realTimePriceOrderNumber"
          @input.native="updataQuantity"
          :min="leastQuantity"
          :max="9999"
          label="描述文字"
        ></el-input-number>
      </div>
    </div>
    <el-divider></el-divider>

    <!-- 备注 -->
    <!-- <div class="fx">
      <el-input
        :rows="4"
        :maxlength="64"
        type="textarea"
        placeholder="其他要求与说明请在此处备注说明,数字限制64位"
        v-model="dataFrom.productRemark"
      ></el-input>
    </div> -->
  </div>
</template>
<script>
import {
  getOptional,
  getPlainPriceRange,
  getDetailSupplier,
  getDetailQuantity,
} from '@/api/detailsApi'
export default {
  name: 'Custom',
  props: {
    DataList: {
      type: Object,
      default() {
        return {}
      },
    },
    leastQuantity: {
      type: Number,
      default: 0,
    },
    packageList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      dataFrom: {
        styleNumber: this.DataList.styleNumber, // 公司款号
        productName: this.DataList.productName,
        quantity: this.leastQuantity || 0, // 数量
        amountRange: 0,
        labelPrice: 0,
        tradePrice: 0,
        maintainSpecification: null,
        goldWeigh: null,
        texture: null,
        supplier: {
          supplierCode: null,
          supplierName: null,
          supplierMobile: null,
          specifications: null,
        },
        productRemark: null,
      },
      supplierOptions: [],
    }
  },
  mounted() {
    // 获取可选属性
    this.getOptional()
    //获取价格范围
    this.getPriceRange()

    this.realTimePriceOrderNumber(this.leastQuantity)

    console.log(this.packageList)
  },
  methods: {
    getQuantity() {
      if (
        !this.dataFrom.styleNumber ||
        !this.dataFrom.texture ||
        !this.dataFrom.goldWeigh
      ) {
        return
      }

      this.dataFrom.supplier.supplierCode = null
      this.dataFrom.supplier.supplierName = null
      this.dataFrom.supplier.supplierMobile = null
      this.dataFrom.supplier.specifications = null

      if (
        ['潮流爆款'].includes(this.DataList.productRemark) &&
        ['戒指', '手镯'].includes(this.DataList.category)
      ) {
        getDetailQuantity({
          styleNumber: this.dataFrom.styleNumber,
        }).then((res) => {
          this.supplierOptions = res.data || []
          this.dataFrom.supplier.supplierCode = this.supplierOptions[0].supplierCode
          this.dataFrom.supplier.supplierName = this.supplierOptions[0].supplierName
          this.dataFrom.supplier.supplierMobile = this.supplierOptions[0].supplierMobile
          this.dataFrom.supplier.specifications = this.supplierOptions[0].specifications
        })
      } else {
        getDetailSupplier({
          styleNumber: this.dataFrom.styleNumber,
          texture: this.dataFrom.texture,
          mainStone: this.dataFrom.goldWeigh,
        }).then((res) => {
          this.supplierOptions = res.data || []
        })
      }
    },

    handleInputSupplier() {
      const targetSupplier = this.supplierOptions.find(
        (item) => item.supplierCode === this.dataFrom.supplier.supplierCode
      )
      if (targetSupplier) {
        this.dataFrom.supplier.supplierCode = targetSupplier.supplierCode
        this.dataFrom.supplier.supplierName = targetSupplier.supplierName
        this.dataFrom.supplier.supplierMobile = targetSupplier.supplierMobile
        this.dataFrom.supplier.specifications = targetSupplier?.specifications
      }
    },

    handleInputQuantity() {
      const targetSupplier = this.supplierOptions.find(
        (item) => item.specifications === this.dataFrom.supplier.specifications
      )
      if (targetSupplier) {
        this.dataFrom.supplier.supplierCode = targetSupplier.supplierCode
        this.dataFrom.supplier.supplierName = targetSupplier.supplierName
        this.dataFrom.supplier.supplierMobile = targetSupplier.supplierMobile
        this.dataFrom.supplier.specifications = targetSupplier?.specifications
      }
    },

    // 获取可选属性
    getOptional() {
      let obj = {
        styleNumber: this.DataList.styleNumber,
        genderCode: '',
      }
      getOptional(obj).then((res) => {
        this.dataFrom = { ...this.dataFrom, ...res.data }
        if (res.data.textureList.length === 1) {
          this.dataFrom.texture = res.data.textureList[0]
        }
        if (res.data.mainStoneList.length === 1) {
          this.dataFrom.goldWeigh = res.data.mainStoneList[0]
        }
        if (res.data?.maintainSpecificationList?.length > 0) {
          this.dataFrom.maintainSpecification =
            res.data.maintainSpecificationList[0]
        }
        this.getQuantity()
        this.getPriceRange()
      })
    },

    //获取价格范围
    getPriceRange() {
      getPlainPriceRange(this.dataFrom).then((res) => {
        this.dataFrom.labelPrice = res.data.labelPrice
        this.dataFrom.tradePrice = res.data.tradePrice
      })
    },

    // 数量改变实时触发
    updataQuantity(event) {
      this.realTimePriceOrderNumber(Number(event.target.value))
    },

    // 数量改变计算价格
    realTimePriceOrderNumber(value) {
      this.getPriceRange()
      this.$emit('selectionCustom', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom {
  .fx {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .title {
    font-size: 18px;
    color: #000;

    .hidden {
      visibility: hidden;
    }
  }

  .placeNum {
    margin-right: 35px;
  }

  .value-font {
    font-size: 18px;
    color: #ec9368;
  }

  .operatingCosts {
    margin-right: 39px;
  }

  .price {
    margin-left: 40px;
  }

  .el-divider--horizontal {
    margin: 17px 0;
  }

  /deep/ .el-radio.is-checked .el-radio__label {
    color: #ec9368 !important;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #ec9368 !important;
    background: #ec9368 !important;
  }
}

/deep/ .el-radio__original {
  display: none !important;
}

/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}
</style>
